// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amp-advertise-container {
  display: flex;
  padding: 36px 30px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 10px;
  background: #fff;
  max-height: 85vh;
  overflow-y: scroll;
}

.custom-advertise-modal .ant-modal-close {
  color: #d2042d;
  top: 36px !important;
  margin-right: 6px !important;
}

.custom-advertise-modal .ant-modal-close:hover {
  color: #a10024;
}

.market-place-title.ant-typography {
  font-family: Montserrat;
  color: var(--Colors-Text-500, #0a0f0d);
  font-size: var(--Font-Font-Size-h5, 17px);
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  align-self: stretch;
}

.marketplace-section.ant-typography {
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.88);
  font-weight: 600;
  line-height: 1.2105263157894737;
}

.maximize-text-row .ant-typography {
  margin-bottom: 5px;
}

.maximize-text {
  font-family: Roboto;
  color: var(--Colors-Text-400, #3b3f3d);
  font-size: var(--Font-Font-Size-p, 14px);
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 5px;
}

.advertiser-information {
  font-family: Roboto;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  text-transform: uppercase;
  margin-top: 1rem;
}

.form-container {
  width: 100%;
  overflow-x: scroll;
  margin-top: 1rem;
  max-height: 35rem;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 1rem;
}

.ad-description {
  width: 100%;
}

.advertise-upload-image {
  margin-left: 0px !important;
  margin-top: 2%;
}

.add-advertise-images {
  text-align: center;
  border-radius: 0.625rem;
  border: 2px dashed #000;
  width: 100%;
  height: 12.5rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.add-advertise-images-container {
  text-align: center;
  border-radius: 0.625rem;
  border: 2px dashed #000;
  height: 12.5rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.advertise-upload-image .ant-row {
  margin-left: 0px !important;
  justify-content: center !important;
  background-color: rgba(0, 0, 0, 0.05);
}
.start-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
  box-shadow: none !important;
  color: inherit !important;
}
.start-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #d2042d !important;
  color: white !important;
  border: #d2042d !important;
}
.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner::before {
  border: none !important;
}
.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
}

.end-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: transparent !important;
  box-shadow: none !important;
  border: none !important;
}
.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
  box-shadow: none !important;
  color: inherit !important;
}
.end-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {
  background-color: #d2042d !important;
  color: white !important;
  border: #d2042d !important;
}
.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner::before {
  border: none !important;
}
.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {
  border: 1px solid #d2042d !important;
}

.custom-advertise-modal-version :where(.ant-modal-content) {
  padding: 0 !important;
}
.supported-formatted-dimensions-versions {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 20px;
  padding-top: 20px;
}
.supported-formatted-dimensions-versions {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.maximize-sub-text-row {
  display: flex;
  width: 80%;
}

.advertise-model-sub-form-row {
  width: 100%;
  margin-left: 0.1rem;
}

.advertise-upload-image-row {
  width: 100%;
  flex-flow: nowrap;
}

.advertise-model-delete-image {
  z-index: 1;
  margin-left: -32px;
}

.advertise-drag-upload-image {
  width: 4rem;
  height: 4rem;
  margin-top: 1%;
}

.advertise-support-image-row {
  justify-content: space-between;
  gap: 20px;
  margin-top: 2%;
}

.advertise-support-image-row-text {
  font-family: Roboto;
  border-radius: 0.1875rem;
  background: #efefef;
  padding: 0.5rem 1rem;
}

.advertise-form-submit-button {
  background-color: #d2042d;
  width: 100%;
  height: 50px;
}

.model-version-form-item-css {
  cursor: pointer;
  width: 100%;
}

.amp-advertise-container::-webkit-scrollbar {
  display: block !important;
  width: 7px !important;
}

.amp-advertise-container::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
  border-radius: 10px !important;
}

.amp-advertise-container::-webkit-scrollbar-thumb {
  background: #888 !important;
  border-radius: 10px !important;
  min-height: 5rem;
}

.amp-advertise-container::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.billboard-datepicker .ant-picker-input input::placeholder,
.billboard-datepicker .ant-picker-input > input {
  font-size: 1rem;
  color: #757575 !important;
  font-family: Roboto !important;
  text-align: left !important;
}
#ad-type,
#type_of_ad_help {
  margin-left: 0.6rem;
}
@media (min-width: 321px) and (max-width: 376px) {
  .market-place-title.ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h5, 14px) !important;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    align-self: stretch;
    font-weight: 600px !important;
  }
  .maximize-text {
    color: var(--Colors-Text-400, #3b3f3d);
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 5px;
  }
  .advertiser-information {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
  }
  .maximize-text-row .ant-typography {
    margin-bottom: 0px;
  }

  .supported-formatted-dimensions-versions {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;
    padding: 0.5rem 1rem;
  }

  .drag-image-icon-version {
    width: 3rem !important;
    height: 3rem !important;
    margin-top: 2%;
  }
  .add-advertise-images {
    border: 2px dashed #000;
    width: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .market-place-title.ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: var(--Font-Font-Size-h5, 14px) !important;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
    align-self: stretch;
    font-weight: 600px !important;
  }
  .maximize-text {
    color: var(--Colors-Text-400, #3b3f3d);
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .advertiser-information {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
  }
  .maximize-text-row .ant-typography {
    margin-bottom: 0px;
  }
  .drag-image-icon-version {
    width: 3rem !important;
    height: 3rem !important;
    margin-top: 2%;
  }
  .drag-test-version {
    color: #000;
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 400;
  }
  .supported-formatted-dimensions-versions {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;
  }
}
@media (min-width: 426xpx) and (max-width: 768px) {
  .supported-formatted-dimensions-versions {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 20px;
  }
}

@media (min-width: 0px) and (max-width: 320px) {
  .market-place-title.ant-typography {
    color: var(--Colors-Text-500, #0a0f0d);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    align-self: stretch;
  }
  .maximize-text {
    color: var(--Colors-Text-400, #3b3f3d);
    font-size: var(--Font-Font-Size-p, 14px);
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 5px;
  }
  .advertiser-information {
    color: var(--Colors-Primary-500, #d2042d);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
  }
  .drag-image-icon-version {
    width: 3rem !important;
    height: 3rem !important;
    margin-top: 2%;
  }
  .add-advertise-images {
    border: 2px dashed #000;
    width: 100%;
    height: auto !important;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .maximize-text-row .ant-typography {
    margin-bottom: 0px;
  }

  .supported-formatted-dimensions-versions {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 1rem;
    padding: 0.5rem 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/advertise-with-amp/AdvertiseModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,qCAAqC;AACvC;AACA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;AACA;;EAEE,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE;IACE,sCAAsC;IACtC,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sCAAsC;IACtC,oDAAoD;IACpD,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;EACX;AACF;AACA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;EACX;AACF;;AAEA;EACE;IACE,sCAAsC;IACtC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,sCAAsC;IACtC,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,yCAAyC;IACzC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,iBAAiB;IACjB,SAAS;IACT,oBAAoB;EACtB;AACF","sourcesContent":[".amp-advertise-container {\n  display: flex;\n  padding: 36px 30px;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 10px;\n  background: #fff;\n  max-height: 85vh;\n  overflow-y: scroll;\n}\n\n.custom-advertise-modal .ant-modal-close {\n  color: #d2042d;\n  top: 36px !important;\n  margin-right: 6px !important;\n}\n\n.custom-advertise-modal .ant-modal-close:hover {\n  color: #a10024;\n}\n\n.market-place-title.ant-typography {\n  font-family: Montserrat;\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-size: var(--Font-Font-Size-h5, 17px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n  align-self: stretch;\n}\n\n.marketplace-section.ant-typography {\n  margin-bottom: 0.5em;\n  color: rgba(0, 0, 0, 0.88);\n  font-weight: 600;\n  line-height: 1.2105263157894737;\n}\n\n.maximize-text-row .ant-typography {\n  margin-bottom: 5px;\n}\n\n.maximize-text {\n  font-family: Roboto;\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-size: var(--Font-Font-Size-p, 14px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  margin-bottom: 5px;\n}\n\n.advertiser-information {\n  font-family: Roboto;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  text-transform: uppercase;\n  margin-top: 1rem;\n}\n\n.form-container {\n  width: 100%;\n  overflow-x: scroll;\n  margin-top: 1rem;\n  max-height: 35rem;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 1rem;\n}\n\n.ad-description {\n  width: 100%;\n}\n\n.advertise-upload-image {\n  margin-left: 0px !important;\n  margin-top: 2%;\n}\n\n.add-advertise-images {\n  text-align: center;\n  border-radius: 0.625rem;\n  border: 2px dashed #000;\n  width: 100%;\n  height: 12.5rem;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.add-advertise-images-container {\n  text-align: center;\n  border-radius: 0.625rem;\n  border: 2px dashed #000;\n  height: 12.5rem;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.advertise-upload-image .ant-row {\n  margin-left: 0px !important;\n  justify-content: center !important;\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.start-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n  box-shadow: none !important;\n  color: inherit !important;\n}\n.start-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n  color: white !important;\n  border: #d2042d !important;\n}\n.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner::before {\n  border: none !important;\n}\n.start-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n}\n\n.end-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  border: none !important;\n}\n.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n  box-shadow: none !important;\n  color: inherit !important;\n}\n.end-date-calendar .ant-picker-cell-selected .ant-picker-cell-inner {\n  background-color: #d2042d !important;\n  color: white !important;\n  border: #d2042d !important;\n}\n.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner::before {\n  border: none !important;\n}\n.end-date-calendar .ant-picker-cell-today .ant-picker-cell-inner {\n  border: 1px solid #d2042d !important;\n}\n\n.custom-advertise-modal-version :where(.ant-modal-content) {\n  padding: 0 !important;\n}\n.supported-formatted-dimensions-versions {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 20px;\n  padding-top: 20px;\n}\n.supported-formatted-dimensions-versions {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.maximize-sub-text-row {\n  display: flex;\n  width: 80%;\n}\n\n.advertise-model-sub-form-row {\n  width: 100%;\n  margin-left: 0.1rem;\n}\n\n.advertise-upload-image-row {\n  width: 100%;\n  flex-flow: nowrap;\n}\n\n.advertise-model-delete-image {\n  z-index: 1;\n  margin-left: -32px;\n}\n\n.advertise-drag-upload-image {\n  width: 4rem;\n  height: 4rem;\n  margin-top: 1%;\n}\n\n.advertise-support-image-row {\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 2%;\n}\n\n.advertise-support-image-row-text {\n  font-family: Roboto;\n  border-radius: 0.1875rem;\n  background: #efefef;\n  padding: 0.5rem 1rem;\n}\n\n.advertise-form-submit-button {\n  background-color: #d2042d;\n  width: 100%;\n  height: 50px;\n}\n\n.model-version-form-item-css {\n  cursor: pointer;\n  width: 100%;\n}\n\n.amp-advertise-container::-webkit-scrollbar {\n  display: block !important;\n  width: 7px !important;\n}\n\n.amp-advertise-container::-webkit-scrollbar-track {\n  background: #f1f1f1 !important;\n  border-radius: 10px !important;\n}\n\n.amp-advertise-container::-webkit-scrollbar-thumb {\n  background: #888 !important;\n  border-radius: 10px !important;\n  min-height: 5rem;\n}\n\n.amp-advertise-container::-webkit-scrollbar-thumb:hover {\n  background: #555 !important;\n}\n.billboard-datepicker .ant-picker-input input::placeholder,\n.billboard-datepicker .ant-picker-input > input {\n  font-size: 1rem;\n  color: #757575 !important;\n  font-family: Roboto !important;\n  text-align: left !important;\n}\n#ad-type,\n#type_of_ad_help {\n  margin-left: 0.6rem;\n}\n@media (min-width: 321px) and (max-width: 376px) {\n  .market-place-title.ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h5, 14px) !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    align-self: stretch;\n    font-weight: 600px !important;\n  }\n  .maximize-text {\n    color: var(--Colors-Text-400, #3b3f3d);\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n    margin-bottom: 5px;\n  }\n  .advertiser-information {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    text-transform: uppercase;\n  }\n  .maximize-text-row .ant-typography {\n    margin-bottom: 0px;\n  }\n\n  .supported-formatted-dimensions-versions {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    gap: 20px;\n    padding: 0.5rem 1rem;\n  }\n\n  .drag-image-icon-version {\n    width: 3rem !important;\n    height: 3rem !important;\n    margin-top: 2%;\n  }\n  .add-advertise-images {\n    border: 2px dashed #000;\n    width: 100%;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .market-place-title.ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: var(--Font-Font-Size-h5, 14px) !important;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 24px;\n    align-self: stretch;\n    font-weight: 600px !important;\n  }\n  .maximize-text {\n    color: var(--Colors-Text-400, #3b3f3d);\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin-bottom: 5px;\n  }\n  .advertiser-information {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    text-transform: uppercase;\n  }\n  .maximize-text-row .ant-typography {\n    margin-bottom: 0px;\n  }\n  .drag-image-icon-version {\n    width: 3rem !important;\n    height: 3rem !important;\n    margin-top: 2%;\n  }\n  .drag-test-version {\n    color: #000;\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 400;\n  }\n  .supported-formatted-dimensions-versions {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    gap: 20px;\n  }\n}\n@media (min-width: 426xpx) and (max-width: 768px) {\n  .supported-formatted-dimensions-versions {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    gap: 20px;\n  }\n}\n\n@media (min-width: 0px) and (max-width: 320px) {\n  .market-place-title.ant-typography {\n    color: var(--Colors-Text-500, #0a0f0d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    align-self: stretch;\n  }\n  .maximize-text {\n    color: var(--Colors-Text-400, #3b3f3d);\n    font-size: var(--Font-Font-Size-p, 14px);\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    margin-bottom: 5px;\n  }\n  .advertiser-information {\n    color: var(--Colors-Primary-500, #d2042d);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px;\n    text-transform: uppercase;\n  }\n  .drag-image-icon-version {\n    width: 3rem !important;\n    height: 3rem !important;\n    margin-top: 2%;\n  }\n  .add-advertise-images {\n    border: 2px dashed #000;\n    width: 100%;\n    height: auto !important;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .maximize-text-row .ant-typography {\n    margin-bottom: 0px;\n  }\n\n  .supported-formatted-dimensions-versions {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    gap: 1rem;\n    padding: 0.5rem 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
